import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (userId) => {
  if (socket) return socket;
  // path matches the server's — nested under /api/, the only nginx location
  // proxying WebSocket upgrades in production (see server.js).
  socket = io(process.env.REACT_APP_BACKEND_URL, { path: "/api/socket.io", query: { userId } });
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  socket?.disconnect();
  socket = null;
};
